import axios from "axios";
import Score from "@/features/Scores/Score";
import Scorecard from "@/features/Scores/Scorecard";
import ScorecardRequestModel from "@/features/Scores/RequestModels/ScorecardRequestModel";
import ScorecardTemplate from "@/features/Scores/ScorecardTemplate";
import Rating from "@/features/Scores/Rating";
import { LatestScoreData } from "@/features/Scores/LatestScoreData";
import { PagingParameter } from "@/shared/models/PagingParameter";

export interface ScorecardListResponse {
    scorecards: Scorecard[];
    totalScorecards: number;
}

interface RequestParam extends PagingParameter {
    supplierID: string;
}

export class ScoreService {
    private scoreURL = "/api/v1/scores";

    async getScoreFromServer(/*id: string*/): Promise<Score> {
        // TODO #3738205

        return new Score();
    }

    async updateScore(/*updatedScore: Score*/): Promise<string> {
        // TODO #3738205

        return "";
    }

    async publishScore(/*id: string*/): Promise<void> {
        // TODO #3738205
    }

    async lockScore(/*id: string*/): Promise<void> {
        // TODO #3738205
    }

    async getScorecardFromServer(id: string): Promise<Scorecard> {
        const response = await axios.get(this.scoreURL + "/scorecard/" + id);

        return response.data;
    }

    async getScorecardsFromServer(query: RequestParam | null = null): Promise<ScorecardListResponse> {
        const response = await axios.get(this.scoreURL + "/scorecards", { params: query });
        return response.data as ScorecardListResponse;
    }

    async createScorecard(supplierID: string): Promise<string> {
        const form = new FormData();
        form.append("supplierID", supplierID);
        form.append("currentDate", new Intl.DateTimeFormat("en-US").format(new Date()));
        const response = await axios.post(this.scoreURL + "/scorecard", form, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });

        return response.data as string;
    }

    async updateScorecard(scorecard: Scorecard): Promise<string> {
        const scoreRequest = new ScorecardRequestModel(scorecard);
        const response = await axios.put(this.scoreURL + "/scorecard/" + scorecard.id, scoreRequest);

        return response.data as string;
    }

    async deleteScorecard(id: string): Promise<void> {
        await axios.delete(this.scoreURL + "/scorecard/" + id);
    }

    async publishScorecard(scorecardID: string): Promise<void> {
        await axios.put(this.scoreURL + "/scorecard/" + scorecardID + "/publish");
    }

    async lockScorecard(scorecardID: string): Promise<void> {
        await axios.put(this.scoreURL + "/scorecard/" + scorecardID + "/lock");
    }

    async getLatestScoreAndPercentChange(supplierID: string): Promise<LatestScoreData> {
        const query = {
            params: { supplierID },
        };
        const response = await axios.get(this.scoreURL + "/scorecards/latestscoreandpercentchange", query);

        return response.data as LatestScoreData;
    }

    async getLastRatings(supplierID: string, date: Date): Promise<Rating[]> {
        const query = {
            params: { date },
        };
        const response = await axios.get(this.scoreURL + "/" + supplierID + "/lastratings", query);

        return response.data as Rating[];
    }

    async getScorecardTemplate(): Promise<ScorecardTemplate> {
        const response = await axios.get(this.scoreURL + "/scorecard/template");
        return response.data as ScorecardTemplate;
    }
}
